// extracted by mini-css-extract-plugin
export var card = "_ue-0";
export var details = "_ue-1";